import React from 'react';
import clsx from 'clsx';
import styles from './WelcomeBubble.module.css';

interface WelcomeBubbleProps {
  message: string;
  onClick: () => void;
  className?: string;
  embedMode?: boolean;
}

export const WelcomeBubble: React.FC<WelcomeBubbleProps> = ({
  message,
  onClick,
  className,
  embedMode = false,
}) => {
  const handleBubbleClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).closest(`.${styles.closeButton}`)) {
      return;
    }
    onClick();
  };

  return (
    <div className={clsx(styles.container, embedMode && styles.embedMode, className)}>
      <div className={styles.bubble} onClick={handleBubbleClick}>
        <div className={styles.content}>
          <div className={styles.messageText}>{message}</div>
        </div>
      </div>
    </div>
  );
};
